<h2>Creación de trabajadores por fichero</h2>
<app-upload-file-page [config]="uploadConfig">
    <div class="alert alert-secondary">
        <p class="m-0">{{ 'workers.upload.HINT_TEXT' | translate }}</p>
    </div>
</app-upload-file-page>